var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 39.2C20 32.4794 20 29.1191 21.3079 26.5521C22.4584 24.2942 24.2942 22.4584 26.5521 21.3079C29.1191 20 32.4794 20 39.2 20H80.8C87.5206 20 90.8809 20 93.4479 21.3079C95.7058 22.4584 97.5416 24.2942 98.6921 26.5521C100 29.1191 100 32.4794 100 39.2V80.8C100 87.5206 100 90.8809 98.6921 93.4479C97.5416 95.7058 95.7058 97.5416 93.4479 98.6921C90.8809 100 87.5206 100 80.8 100H39.2C32.4794 100 29.1191 100 26.5521 98.6921C24.2942 97.5416 22.4584 95.7058 21.3079 93.4479C20 90.8809 20 87.5206 20 80.8V39.2Z",
    fill: "#E7F4EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6455 59.4718C41.0341 58.7492 41.0786 57.6786 41.7479 57.0093L43.1376 55.6196C43.8484 54.9088 45.0007 54.9088 45.7115 55.6196L54.4178 64.3258C54.5877 64.4957 54.8604 64.5042 55.0406 64.3453L75.3159 46.4553C76.0365 45.8194 77.1274 45.8535 77.8069 46.5331L78.254 46.9801C78.946 47.6721 78.9669 48.7874 78.3013 49.5048L56.117 73.4178C55.3743 74.2184 54.0987 74.1892 53.3933 73.3556L41.6455 59.4718Z",
    fill: "url(#paint0_linear_3656_55065)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3656_55065",
    x1: 60.0009,
    y1: 46,
    x2: 60.0009,
    y2: 74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A15A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24893A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessLarge);
export default __webpack_public_path__ + "static/media/successLarge.8d8c2c83ffcfacebb64524f0dc8d3092.svg";
export { ForwardRef as ReactComponent };